/** Определяет, нужно ли отображать блок на странице или нет.
 * Блок должен показываться на странице крупной техники
 * Временный хелпер, до момента пока это не будет реализовано в апи.
 */

export default function isLargeEquipment({ path }: { path: string }) {
  const categories = ['kbt']
  return categories.some(q => path && path.includes(q))
}
